import React from 'react';
import {FlatList, Platform, View} from 'react-native';

import Card from '/component/base/Card';
import Text from '/component/base/Text';
import {Cards} from '/constant/TestIDs';

import {useCoachesTeamSummaryCard} from './CoachesTeamSummaryCard.hook';
import {styles} from './CoachesTeamSummaryCard.style';
import {CoachesTeamSummaryCardProps} from './CoachesTeamSummaryCard.types';
import {getHeading} from './CoachesTeamSummaryCard.util';
import {CoachesTeamSummaryCardItem} from './CoachesTeamSummaryCardItem';

export const CoachesTeamSummaryCard = ({
  currentUserCompetency,
  metrics,
  style = {},
}: CoachesTeamSummaryCardProps) => {
  const {isBusinessCoach, isBusinessLeader, firstItems, secondItems, tt} =
    useCoachesTeamSummaryCard({currentUserCompetency, metrics});

  const renderItem = (props: any) => (
    <CoachesTeamSummaryCardItem
      {...props}
      isBusinessLeader={isBusinessLeader}
    />
  );

  const keyExtractor = (item: any) => item.testID;

  return (
    <Card
      fullWidth
      testID={Cards.coachesTeamsSummaryCard}
      style={{...styles.base, ...style}}>
      <View accessible={Platform.OS === 'android'}>
        <Text
          accessible={true}
          accessibilityRole="header"
          testID={Cards.coachesTeamsSummaryCardTitle}
          variant="heading"
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.cardHeaderText}>
          {getHeading({isBusinessCoach, isBusinessLeader, tt})}
        </Text>
      </View>
      <FlatList
        data={firstItems}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
        scrollEnabled={false}
      />
      <View style={styles.divider} />
      <FlatList
        data={secondItems}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
        scrollEnabled={false}
      />
    </Card>
  );
};

export default CoachesTeamSummaryCard;
